'use strict';

module.exports = {

	getClient: function () {
		var currentHost = document.location.host,
			currentPath = document.location.pathname,
			client;

		if (currentHost.indexOf('svtplay.se') > -1) {
			client = 'svt-play';
		} else if (currentHost.indexOf('svt.se') > -1) {
			if (currentPath.indexOf('/barnkanalen/barnplay/') > -1 ||
                currentPath.match(/\/barnkanalen\/$/) !== null) { //same as String.endsWith('/barnkanalen/')
				client = 'barnplay';
			} else if (currentPath.indexOf('/barnkanalen/bolibompa/') > -1) {
				client = 'bolibompa';
			} else if (currentPath.indexOf('/barnkanalen/') > -1 ||
					currentPath.indexOf('/mixat/') > -1) {
				client = 'barnkanalen';
			} else if (currentPath.indexOf('/nyheter/') > -1 ||
					currentPath.indexOf('/kultur/') > -1 ||
					currentPath.indexOf('/vader/') > -1 ||
					currentPath.indexOf('/opinion/') > -1) {
				client = 'svtse-nyheter';
			}	else if (currentPath.indexOf('/sport/') > -1) {
				client = 'svtse-sport';
			} else if (currentPath.indexOf('/videoplayer-embed/') > -1) {
				client = 'external';
			} else {
				client = 'svtse';
			}
		} else if (currentHost.indexOf('oppetarkiv.se') > -1) {
			client = 'oppet-arkiv';
		} else {
			client = 'external';
		}

		return client;
	},

	getComscoreBaseUrl: function () {
		var currentHost = document.location.host,
			account;

		if (currentHost.indexOf('www.svtplay.se') > -1 ||
			currentHost.indexOf('www.svt.se') > -1 ||
			currentHost.indexOf('www.oppetarkiv.se') > -1) {
			account = 'svt';
		} else {
			account = 'test';
		}

		return 'http' + (document.location.href.charAt(4) === 's' ? 's://' : '://') + 'ld.svt.se/svt/' + account + '/s?';
	},

	getScorecardResearchUrl: function () {
		return 'http' + (document.location.href.charAt(4) === 's' ? 's://sb' : '://b') + '.scorecardresearch.com/b?c1=2';
	},

	getComscoreSite: function () {
		var currentHost = document.location.host,
			account;

		if (currentHost.indexOf('www.svtplay.se') > -1 ||
			currentHost.indexOf('www.svt.se') > -1 ||
			currentHost.indexOf('www.oppetarkiv.se') > -1) {
			account = 'svt';
		} else {
			account = 'test';
		}

		return account;
	},

	getComscoreC2Value: function () {
		return '21885884';
	},

	getMmsClientNr: function () {
		return '1001001';
	}

};



// WEBPACK FOOTER //
// ./src/js/util/stats.js